<template>
    <!-- 会员功能介绍 -->
	<div class="page2">
        <div class="vip-introduce">     
            <div class="swiper-page" v-for="(item, i) in introData" :key="i" v-if="i === currentIndex">
                <transition name="fade">
                    <div>
                        <div class="intro-left" v-if="i === currentIndex">
                            <p class="intro-title">
                                {{ item.introTitle }}
                                <i class="under-line"></i>
                            </p>
                            <div class="intro-desc">
                                <p class="desc-content" v-for="content in item.introDesc">
                                    <i class="desc-icon"></i>
                                    <span class="desc-text">{{ content }}</span>
                                </p>
                                <div class="btn-buyvip" @click="showDialog(item.actionType)">
                                    <p class="btn-text">{{ item.introBtnText }}</p>
                                </div>
                            </div>
                        </div>
                        <div class="intro-right" v-if="i === currentIndex">
                            <img :src="item.introDemoImg" alt="" class="intro-demoimmg">
                        </div>
                    </div>
                </transition>
            </div>
            <div class="vip-intro-pagination" slot="pagination">
                <div class="intro-nav">
                    <ul>
                        <li class="custom-index" v-for="(item, i) in introData" @click="changeIndex(i, item.tabActionType)">
                            <i class="active-bg" :class="{'active': i === currentIndex}"></i>
                            <p class="custom-text" :class="{'active-text': i === currentIndex}">{{item.introTitle}}</p>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { introData } from '@/data/data.js';
    export default {
        name: 'vipIntroduce',
        components: {
        },
        data() {
            let _this = this;
            return {
                total: 3,   //共计
                currentIndex: 1, //当前的swiper index
                introData,
            }
        },
        mounted(){
            this.autoPlay();
        },
        methods: {
            //点击分页器
            changeIndex(index, actionType){
                this.currentIndex = index;
                window.clickLog && window.clickLog(`from=${actionType}`)
            },
            //初始化
            autoPlay(){
                this.play();
                setInterval(this.play, 10000);
            },
            play(){
                this.currentIndex ++;
                if( this.currentIndex === this.introData.length) {
                    this.currentIndex = 0;
                }
            },
            showDialog (actionType) {
                this.$emit('showDialog');
                window.clickLog && window.clickLog(`from=${actionType}`);
            }
        }
    }
    
</script>

<style lang="scss" scope>
    .page2{
        height: 100%;
        width: 100%;
        position: relative;
        background: url(../../../../assets/imgs/bg-page2.png) no-repeat center;
        background-size: 100% 100%;
    }
    .vip-introduce{
		width: 1190px;
        height: 700px;
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        margin: auto;
        .swiper-page{
            width: 1190px;
            height: 600px;
            position: relative;
        }
        .fade-enter-active, .fade-leave-active {
            transition: all .5s;
            -moz-transition: all .5s;
            -webkit-transition: all .5s;
            -o-transition: all .5s;
        }
        .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
            opacity: 0;
            left: 0;
            right: 0;
        }
        .intro-left{
            .intro-title{
                font-size: 44px;
                color: #FFFFFF;
                letter-spacing: 0;
                position: absolute;
                top: 100px;
                left: 10px;
                display: inline-block;
                animation: introTitle .8s linear ;
                .under-line{
                    width: 50px;
                    height: 6px;
                    display: inline-block;
                    background: #DBB06E;
                    border-radius: 100px;
                    position: absolute;
                    top: 65px;
                    left: 0;
                }
            }
            @keyframes introTitle{
                from {left: -50px; opacity: 0;}
                to {left: 10px; opacity: 1}
            }
            .intro-desc{
                width: 500px;
                height: 170px; 
                position: absolute;
                top: 248px;
                left: 10px;
                animation: introDesc 1.1s linear;
                .desc-content{
                    margin-bottom: 20px;
                    padding-left: 10px;
                }
                .desc-icon{
                    display: inline-block;
                    width: 6px;
                    height: 6px;
                    background: #DBB06E;
                    vertical-align: middle;
                }
                .desc-text{
                    width: 450px;
                    opacity: 0.5;
                    font-size: 16px;
                    color: #FFFFFF;
                    letter-spacing: 0;
                    padding-left: 24px;
                    display: inline-block;
                    vertical-align: middle;
                }

                .btn-buyvip{
                    width: 292px;
                    height: 94px;
                    background: url(../../../../assets/imgs/btn-normal.png) no-repeat center;
                    background-size: 100% 100%;
                    position: absolute;
                    top: 180px;
                    left: -20px;
                    cursor: pointer;
                    &:hover {
                        background: url(../../../../assets/imgs/btn-hover.png) no-repeat center;
                        background-size: 100% 100%;
                    }
                    .btn-text{
                        height: 50px;
                        line-height: 50px;
                        padding-top: 14px;
                        font-weight: bold;
                        font-size: 16px;
                        color: #403C36;
                        letter-spacing: 0;
                        text-align: center;
                        text-shadow: 0 1px 0 rgba(255,255,255,0.22);
                    }
                }
            }
            @keyframes introDesc {
                from {left: -50px; opacity: 0;}
                to {left: 10px; opacity: 1}
            }
        }
        .intro-right{  
            position: absolute;
            right: 20px;
            top: 100px;
            width: 500px;
            height: 400px;
            animation: introRight 1s;
            img{
                width: 500px;
                height: 400px;
            }
        }
        @keyframes introRight{
            from {right: -50px; opacity: 0;}
            to {right: 20px; opacity: 1}
        }
        .intro-nav{
            width: 1191px;
            height: 80px;
            position: relative;
            font-size: 0;
            .custom-index{
                height: 80px;
                width: 396px;
                display: inline-block;
                background: #2D2B29;
                margin-right: 1px;
                position: relative;
                border-radius: 2px 2px 0 0;
                cursor: pointer;
                &:hover{
                    .custom-text{
                        color: #E6CA99;
                        opacity: 1;
                    }
                }
                .active-text{
                    font-size: 20px;
                    color: #E6CA99;
                    opacity: 1;
                    position: absolute;
                }
            }
            .active-bg{
                display: inline-block;
                width: 0px;
                height: 80px;
                position: absolute;
                left: 0;
                top: 0;
                background: url(../../../../assets/imgs/chosed-bg.png) no-repeat center;
                transition: all .3s;
                -moz-transition: all .5s;
                -webkit-transition: all .5s;
                -o-transition: all .5s;
            }
            .active {
                width: 396px;
            }
            .custom-text{
                width: 396px;
                height: 80px;
                text-align: center;
                line-height: 80px;
                opacity: 0.3;
                font-size: 18px;
                color: #FFFFFF;
                position: absolute;
                left: 0;
                top:0;
                transition: all .3s;
                -moz-transition: all .5s;
                -webkit-transition: all .5s;
                -o-transition: all .5s;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// VipIntroduce.vue?11ee664f